import { sourceUiStatus } from "@/components/source-card";
import type { Clip } from "@/features/clips/types";
import type { Moment } from "@/features/moments/types";

import type { Source, SourcePipelineStatus } from "./types";

export type ReviewFilter = "ready" | "processing" | "attention" | "approved";

export const reviewFilters: Array<{ value: ReviewFilter; label: string }> = [
  { value: "ready", label: "Ready for review" },
  { value: "processing", label: "Processing" },
  { value: "attention", label: "Needs attention" },
  { value: "approved", label: "Approved" }
];

export function buildReviewGroups(
  sources: Source[],
  moments: Moment[],
  clips: Clip[],
  statusBySource: Map<string, SourcePipelineStatus>
): Record<ReviewFilter, Source[]> {
  const groups: Record<ReviewFilter, Source[]> = { ready: [], processing: [], attention: [], approved: [] };
  for (const source of sources) {
    const sourceMoments = moments.filter((moment) => moment.source_id === source.id);
    const sourceClips = clips.filter((clip) => clip.source_id === source.id);
    const status = sourceUiStatus(source, statusBySource.get(source.id) ?? null, sourceMoments, sourceClips);
    if (status === "needs_review") groups.ready.push(source);
    else if (status === "processing") groups.processing.push(source);
    else if (status === "approved") groups.approved.push(source);
    else groups.attention.push(source);
  }
  return groups;
}
